import * as Yup from 'yup';
import { CommonMessages } from '../messages/validationMessages';


// Validation schema for Carwash Info
export const carbankingInfoSchema = Yup.object({
    information: Yup.boolean(),

    PaymentMethod: Yup.string()
        .when('information', {
            is: true,
            then: (schema) =>
                schema.required(CommonMessages.paymentType_required).notOneOf(['0'], CommonMessages.paymentType_required),
            otherwise: (schema) => schema.notRequired(),
        }),

    stripeSecretKey: Yup.string()
        .when('information', {
            is: true,
            then: (schema) => schema.required(CommonMessages.stripeSecretKey_required),
            otherwise: (schema) => schema.notRequired(),
        }),

    stripePublicKey: Yup.string()
        .when('information', {
            is: true,
            then: (schema) => schema.required(CommonMessages.stripePublicKey_required),
            otherwise: (schema) => schema.notRequired(),
        }),
});


// Validation schema for Location Info
export const locbankingInfoSchema = Yup.object({
    information: Yup.boolean(),

    locationId: Yup.string()
        .when('information', {
            is: false,
            then: (schema) =>
                schema
                    .required(CommonMessages.location_required)
                    .notOneOf(['0'], CommonMessages.location_required),
            otherwise: (schema) => schema.notRequired(),
        }),

        PaymentMethod: Yup.string()
        .when('information', {
            is: false,
            then: (schema) =>
                schema.required(CommonMessages.paymentType_required).notOneOf(['0'], CommonMessages.paymentType_required),
            otherwise: (schema) => schema.notRequired(),
        }),

    stripeSecretKey: Yup.string()
        .when('information', {
            is: false,
            then: (schema) => schema.required(CommonMessages.stripeSecretKey_required),
            otherwise: (schema) => schema.notRequired(),
        }),

    stripePublicKey: Yup.string()
        .when('information', {
            is: false,
            then: (schema) => schema.required(CommonMessages.stripePublicKey_required),
            otherwise: (schema) => schema.notRequired(),
        }),
});

